

import React from "react";

import { useDispatch,useSelector } from 'react-redux';
const SelectOptionCard = ({name,title,setName,setOpenPopUp}) =>{
      const dispatch = useDispatch();
  const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorTextDirection='left',CursorText) =>
    {
      
      dispatch({type: "CURSORTEXTDIRECTION",payload:CursorTextDirection  });
      dispatch({type: "CURSOR",payload:true  });
  
      dispatch({type: "CURSORTEXT",payload:CursorText})
      dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
      dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
    }
     
    const handleMouseLeave = () => {
      dispatch({type: "CURSORTEXTDIRECTION",payload:""  });
      
      dispatch({type: "CURSOR",payload:false})
  
      dispatch({type: "CURSORTEXT",payload:""})
  
      dispatch({type: "CURSORTEXTBG",payload:""})
      dispatch({type: "CURSORTEXTCOLOR",payload:""})
    
  
  }
return(<>

<label style={{margin:"10px"}} onMouseEnter={
()=>handleMouseEnter("#fff","#333","","")}
onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>

<div >{title}</div> 

<input type="radio" title={title} 
checked={name==title?"yes":""} 
className="input-textbox"  value={title}  name={title} 
onChange={e=>{

    setName(e.target.value)
    
}

}

onClick={e=>{
    setName(e.target.value)
     setOpenPopUp(false)
}

}
/>
  <span class={"boxCardBorder"}></span>
</label>

</>)
}
export default SelectOptionCard;